<template>
  <div>
    <px-view-header title="Cadastro de grupos de fornecedores" title-class="font-weight-bold"
                    :breadcrumbs="breadcrumbs">
      <template v-slot:before>
        <v-btn class="mb-4 mr-1" icon x-large color="primary" @click="onClickBack">
          <v-icon>
            mdi-arrow-left
          </v-icon>
        </v-btn>
      </template>
    </px-view-header>
    <div v-if="loadingFornecedorGestaoGrupos">
      <px-circular-loading/>
    </div>
    <div v-if="!loadingFornecedorGestaoGrupos" class="mt-3">
      <v-row dense>
        <v-col cols="12">
          <v-subheader class="body-1 grey lighten-4 text--primary">
            <v-icon>
              mdi-text-box-outline
            </v-icon>
            <span class="ml-2">Dados gerais</span>
          </v-subheader>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12" sm="6">
          <v-text-field
            dense
            outlined
            required
            hide-details
            maxlength="255"
            class="required rounded-tag-small"
            label="Descrição"
            :error="$v.fornecedorGestaoGrupos.descricao.$error"
            @blur="$v.fornecedorGestaoGrupos.descricao.$touch()"
            v-model="fornecedorGestaoGrupos.descricao"
          />
        </v-col>
        <v-col cols="12" sm="2">
          <v-switch dense
                    hide-details
                    class="pa-0 mt-2 mr-2"
                    label="Ativo"
                    color="primary"
                    v-model="fornecedorGestaoGrupos.ativo"/>
        </v-col>
      </v-row>
      <v-row dense class="mt-3">
        <v-col cols="12">
          <v-subheader class="body-1 grey lighten-4 text--primary">
            <v-icon>
              mdi-text-box-outline
            </v-icon>
            <span class="ml-2">Fornecedores</span>
          </v-subheader>
        </v-col>
      </v-row>
      <v-simple-table
        fixed-header
      >
        <template v-slot:default>
          <tbody>
          <tr style="height: 55px" v-for="(fornecedor, index) in fornecedorGestaoGrupos.itens"
              :key="fornecedor.$$id">
            <td class="px-1">
              <px-autocomplete-fornecedor show-cnpj
                show-codigo
                show-endereco
                dense
                path="fornecedor/score"
                v-model="fornecedor.fornecedor"
                :disabled="!!fornecedor.fornecedor"
                class="required rounded-tag-small"
                :error="$v.fornecedorGestaoGrupos.itens.$each[index].fornecedor.$error"
                @blur="$v.fornecedorGestaoGrupos.itens.$each[index].fornecedor.$touch()"
                required/>
            </td>
            <td width="100px">
              <v-btn icon @click="onRemoveItem(index)">
                <v-icon>
                  mdi-close
                </v-icon>
              </v-btn>
            </td>
          </tr>
          </tbody>
        </template>
      </v-simple-table>
      <v-row dense class="mt-2">
        <v-col cols="12" class="text-right">
          <v-btn small class="elevation-0 rounded-tag-small normal-btn-text"
                 color="primary"
                 @click="onClickAddFornecedor">
            <v-icon left small>
              mdi-plus
            </v-icon>
            Adicionar Fornecedor
          </v-btn>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12">
          <v-btn class="elevation-0 normal-btn-text rounded-tag-small"
                 color="primary"
                 :disabled="loadingSave"
                 @click="onClickSave">
            Salvar
          </v-btn>
          <v-btn class="elevation-0 normal-btn-text rounded-tag-small ml-3"
                 @click="onClickBack">
            Cancelar
          </v-btn>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import { uniqueId } from 'lodash';
import validationMixin from '@/mixins/validation-mixin';
import FornecedorGestaoGruposService from '@/modules/gestao-fornecedor-grupos/fornecedor-gestao-grupos-service';

const initalState = () => ({
  $$id: uniqueId(),
  fornecedor: null,
});

export default {
  mixins: [validationMixin],
  data() {
    return {
      id: this.$route.params.id,
      loadingFornecedorGestaoGrupos: false,
      loadingSave: false,
      fornecedorGestaoGrupos: {
        descricao: null,
        ativo: true,
        itens: [initalState()],
      },
      breadcrumbs: [
        { text: 'Gestão de fornecedores' },
        { text: 'Grupos de fornecedores', to: '/fornecedores-gestao-grupos' },
        { text: 'Cadastro' },
      ],
    };
  },
  computed: {
    isEdicao() {
      return !!this.id;
    },
  },
  methods: {
    onChangeFormaPagamento() {
      this.fornecedorGestaoGrupos.prazoPagamento = null;
    },
    onClickBack() {
      this.$router.push({ name: 'main.fornecedores-gestao-grupos' });
    },
    onClickAddFornecedor() {
      this.fornecedorGestaoGrupos.itens.push(initalState());
    },
    onRemoveItem(index) {
      this.fornecedorGestaoGrupos.itens.splice(index, 1);
    },
    buildPayload() {
      const grupo = {
        ...this.fornecedorGestaoGrupos,
      };
      grupo.itens = grupo.itens.map(item => ({
        fornecedor: {
          id: item.fornecedor.id,
        },
      }));
      return grupo;
    },
    onClickSave() {
      if (this.validateForm()) {
        return;
      }
      this.loadingSave = true;
      FornecedorGestaoGruposService.save(this.buildPayload())
        .then(() => {
          const successMessage = this.fornecedorGestaoGrupos.id
            ? 'Grupo de fornecedores atualizado'
            : 'Grupo de fornecedores criado';
          this.$toast(successMessage, { color: 'success' });
          this.onClickBack();
        })
        .finally(() => {
          this.loadingSave = false;
        });
    },
    getFornecedorGestaoGrupos() {
      this.loadingFornecedorGestaoGrupos = true;
      FornecedorGestaoGruposService.get(this.id)
        .then((response) => {
          this.fornecedorGestaoGrupos = response.data;
          this.fornecedorGestaoGrupos.itens = this.fornecedorGestaoGrupos.itens.map(item => ({
            ...item,
            fornecedor: {
              ...item.fornecedor,
              codigoInterno: item.codigoInternoFornecedor,
            },
          }));
        })
        .finally(() => {
          this.loadingFornecedorGestaoGrupos = false;
        });
    },
  },
  created() {
    if (this.isEdicao) {
      this.getFornecedorGestaoGrupos();
    }
  },
  validations: {
    fornecedorGestaoGrupos: {
      descricao: {
        required,
      },
      itens: {
        $each: {
          fornecedor: {
            required,
          },
        },
      },
    },
  },
};
</script>
